import { formatDate } from "../../../../../utilities/formatDate";
export var ToDocumentRowViewModel = function (document) {
    return {
        LeadKycId: document.LeadKycId,
        approvedBy: document.approvedBy || '',
        approvedDate: formatDate(document.approvedDate),
        comment: document.comment || '',
        commentedBy: document.commentedBy || '',
        commentDate: formatDate(document.commentDate),
        dateValidation: document.dateValidation,
        fileId: document.fileId,
        kycDocumentName: document.kycDocumentName,
        kycId: document.kycId,
        leadKycDocumentId: document.leadKycDocumentId,
        notarized: document.notarized,
        status: document.status,
        uploadDate: formatDate(document.uploadDate),
        validThrough: document.validThrough
    };
};
